// Region-level prose (About section in the region sidebar): growing
// conditions + history per region. Germany has none — the section only
// renders for regions with an entry, so this stays empty and invisible
// here; the michigan atlas pack shadows it with real AVA content.
export const REGION_CONTENT = {};
